<ng-container *ngIf="!showBusyIndicator && isSessionActive && !isWebView && !sessionFailed">
  <app-sidenav
    (onToggleSidenav)="onToggleSidenav($event)"
    [brand]="brand"
    [navbarMenus]="navbarMenus"
  ></app-sidenav>
  <app-body
    [isSideNavExpanded]="isSidenavExpanded"
    [screenWidth]="screenWidth"
    [userProfile]="user"
  ></app-body>
</ng-container>
<mat-spinner
  *ngIf="showBusyIndicator && isSessionActive && !isWebView && !sessionFailed"
  style="margin: auto"
></mat-spinner>
<ng-container *ngIf="!isSessionActive && !isWebView">
  <app-login></app-login>
</ng-container>
<ng-container *ngIf="sessionFailed">
  <app-sessionFailed></app-sessionFailed>
</ng-container>
<ng-container *ngIf="isWebView">
  <app-body
    [isSideNavExpanded]="isSidenavExpanded"
    [screenWidth]="screenWidth"
    [userProfile]="user"
  ></app-body>
</ng-container>
<link href="https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp" rel="stylesheet">

